export default __webpack_public_path__ + "static/media/search.6ca8083b.png";